import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler, XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {watchlist_template} from "../components/templates/watchlist_template";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import {header} from "./header";
import { sleep} from "../utils/Helpers";
import HttpRequests from "../utils/HttpRequest";


declare var ko: any;
declare var page: any;

let chartDiv;

export class watchlist extends vnModule_knockoutJS{

    protected XHRHdl: XMLHttpRequestHandler;
    protected XHRHdls: XMLHttpRequestHandler[] = [];
    protected watchlistList: watchlist_template;
    protected viewPageUrl;

    protected getModuleName(){

        return "watchlist";
    }

    buildContent() : Array<Element>{

        // create validation errors list template
        this.watchlistList = new watchlist_template("list", this.viewModel, this);
        this.template = this.watchlistList;

        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle("Watchlist");

        return [this.watchlistList.build()];
    }

    public fillPage() : void{

        this.updateViewModelFromPath();
        this.getChartData();
    }

    protected getChartData(){

        if( this.XHRHdl ){
            this.XHRHdl.cancelAndReset();
        }

        chartDiv = document.getElementById("watchlistDashboard");

        this.watchlistList.getTemplateViewModel().watchlistIsLoaded(false)
        this.watchlistList.getAutoRefresh().getTemplateViewModel().autoRefreshDisabled(true);

        let usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params["idBrand"] + '/watchlist/shortTermReportCharts/get/';
        let subViewModel = this.watchlistList.getViewModelForRequest();
        let usrReq_params: Array<Array<string>> = [];
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);
        this.sendFilterCall(usrReq_url, subViewModel, this.onGetChartData, XMLHttpRequestHandler_requestType.POST, 'watchlist', chartDiv, false);
    }

    protected onGetChartData(req, obj) {
        return () => {
            obj.manageResponse(req, obj, async () => {


                if(obj.XHRHdls['batchRequest'] != undefined || obj.XHRHdls['batchRequest'] != null){
                    obj.XHRHdls['batchRequest'].cancelRequest()
                    obj.watchlistList.resetCurrentBatch()
                }

                if(req.request.status == 200 && req.request.readyState == 4){
                    let responseParsed = JSON.parse(req.request.response, function (key, value) {
                        return key == "date" || key == "publishDate" || key == "republishDate" ? new Date(value) : value;
                    });
                    //This function does a lot a work, we will await it
                    obj.watchlistList.setWatchlist(responseParsed).then(() => {
                        obj.loadingOut(obj.getChartDiv());
                        obj.watchlistList.getAutoRefresh().getTemplateViewModel().autoRefreshDisabled(false);
                    });
                    obj.watchlistList.getTemplateViewModel().watchlistIsLoaded(true);
                }
            });


        }
    }

    public getChartDiv(){
        return chartDiv;
    }

    protected viewArticle(id){

        this.viewPageUrl = '/brand/' + this.getVnAppZone().app.params.idBrand + '/articles/view/';
        let viewUrl = window.location.origin+this.viewPageUrl + id;
        window.open(viewUrl, '_blank');
        // let editUrl = window.location.origin + '/brand/' + this.getVnAppZone().app.params.idBrand + '/articles/edit/' + id
        // this.savePreviousPage(viewUrl, window.location.href);
        // this.savePreviousPage(editUrl, window.location.href);
        // page(this.viewPageUrl+id)
    }

    public removeFromWatchlist(data){

        let usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params["idBrand"] + "/watchlist/removeFromWatchlist";
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", data]);
        this.XHRHdls['removeFromWatchlist'] = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdls['removeFromWatchlist'].mode = XMLHttpRequestHandler_requestType.POST;
        this.XHRHdls['removeFromWatchlist'].onReadyStateFunction = this.onRemoveFromWatchlist;
        this.XHRHdls['removeFromWatchlist'].execute();
    }

    public onRemoveFromWatchlist(req, obj){
        return () => {
            obj.manageResponse(req, obj, () => {
                if (req.request.status === 200) {
                    const watchlist = obj.watchlistList.getTemplateViewModel().watchlist()
                    obj.editWatchlistOrder(watchlist)
                }
            })

        }
    }



    public editWatchlistOrder(data){
        if(this.XHRHdls['editWatchlistOrder']){
            this.XHRHdls['editWatchlistOrder'].cancelAndReset()
        }
        let usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + "/watchlist/editWatchlistOrder";
        let usrReq_params: Array<Array<string>> = [];
        const flatData = data.map(item => item.article);
        usrReq_params.push(["data", ko.toJSON(flatData)]);
        this.XHRHdls['editWatchlistOrder'] = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdls['editWatchlistOrder'].mode = XMLHttpRequestHandler_requestType.POST;
        this.XHRHdls['editWatchlistOrder'].onReadyStateFunction = () => {};
        this.XHRHdls['editWatchlistOrder'].execute();
    }


    public copyToClipboardAlert(){
        this.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, 'Copied To Clipboard');
        this.getVnAppZone().showNotificationToModule();
    }

    protected getShortTermReport(idArticle) {
        if (this.XHRHdls['getShortTermReport']) {
            this.XHRHdls['getShortTermReport'].cancelAndReset();
        }

        chartDiv = document.getElementById("shortTermReportFormGroup");
        if(chartDiv){
            this.loadingIn(chartDiv);
        }

        let idBrand = this.getVnAppZone().getApp().params.idBrand;

        let usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params["idBrand"] + '/articles/shortTermReport/get/' + idArticle;
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", this.watchlistList.getTemplateViewModel().shortTermReportRange()]);

        this.XHRHdls['getShortTermReport'] = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdls['getShortTermReport'].onReadyStateFunction = this.onGetShortTermReportReturn;
        this.XHRHdls['getShortTermReport'].execute();
    }

    protected onGetShortTermReportReturn(req, obj) {
        return () => {
            obj.manageResponse(req, obj, () => {
                let responseParsed = JSON.parse(req.request.response,function (key, value) {
                    return key == "date" || key == "publishDate" || key == "republishDate" ? new Date(value) : value;
                });
                obj.watchlistList.setShortTermReport(responseParsed);
                obj.watchlistList.getTemplateViewModel().watchlistIsLoaded(true);
            });
            if(obj.getChartDiv()){
                obj.loadingOut(obj.getChartDiv());
            }
        }
    }

    public async filterAutoRefreshStatusOnChange() {
        if(!this.watchlistList.getAutoRefresh().getTemplateViewModel().toggleAutoRefresh()){
            this.watchlistList.resetCurrentBatch()
            this.removeLoadingClassAnimation()
        }

        this.watchlistList.getAutoRefresh().getTemplateViewModel().callRefresh()
    }

    /**
     * Process a batch request.
     *
     * @param {number} batchNumber - The number of the batch to process.
     * @return {Promise<boolean>} A promise that resolves to true if the batch request was processed successfully.
     */
    private processBatchRequest(batchNumber: number): Promise<boolean> {
        return new Promise(async (resolve, reject) => {
            try {
                await sleep(30000)
                const url: string = `/api/brand/${this.getVnAppZone().app.params["idBrand"]}/watchlist/shortTermReportCharts/get/`;
                //Batch must be updated constantly because of reordering and removing items
                const chunks = await this.getBatchState()

                const totalBatch = chunks.length;
                const toggleEnable = await this.getToggleState()
                if (toggleEnable) {
                    const currentChunk = chunks[batchNumber]
                    const elementIds = currentChunk().map(x => `#trend-${x}`)
                    const chunkSubVM = this.watchlistList.getViewModelForBatchRequest(currentChunk)
                    const json = ko.toJSON(chunkSubVM)
                    const batchXhr = new HttpRequests()
                    this.XHRHdls['batchRequest'] = batchXhr

                    try {
                        let chunkTableData = await batchXhr.makeHttpRequest("POST", url, {data: json})

                        chunkTableData = JSON.parse(chunkTableData, (key, value) => {
                            return key == "date" || key == "publishDate" || key == "republishDate" ? new Date(value) : value;
                        })

                        await this.addLoadingClassAnimation(elementIds)
                        await this.watchlistList.getwatchlistChart().drawListCharts(chunkTableData, true)
                        console.log(`Batch ${batchNumber + 1} of ${totalBatch} completed`)

                        this.watchlistList.incrCurrentBatch()
                        if (batchNumber == totalBatch - 1) this.watchlistList.resetCurrentBatch()

                    }catch (e) {
                        console.log("continue")
                    }
                }else{
                    this.watchlistList.resetCurrentBatch()
                }
                resolve(true)

            } catch (e) {
                reject(e)
            }
        })
    }



    private addLoadingClassAnimation(elementIds: Array<string>): Promise<void> {
        return new Promise((resolve) => {
            setTimeout(() => {
                elementIds.forEach(x => {
                    const element = document.querySelector(x);
                    if (element) {
                        element.classList.add('is-batch-queued');
                    }
                });
                resolve();
            }, 5000); // Delay execution by 5 seconds (5000 milliseconds)
        });
    }

    private removeLoadingClassAnimation() {
        // Get all elements with the specified class name
        const elements = document.querySelectorAll('.is-batch-queued' );
        elements.forEach(function (element) {
            element.classList.remove('is-batch-queued');
        });
    }

    public async autoRefresh(){
        await this.processBatchRequest(this.watchlistList.getCurrentBatch())
        this.watchlistList.getAutoRefresh().getTemplateViewModel().callRefresh()
    }


    /**
     * Retrieves the current toggle state of the watchlist auto-refresh feature.
     *
     * @return {Promise<boolean>} A promise that resolves with the current toggle state.
     */
    public getToggleState(): Promise<boolean>{
        return Promise.resolve(this.watchlistList.getAutoRefresh().getTemplateViewModel().toggleAutoRefresh())
    }

    public getWatchListState(){
        return Promise.resolve(this.watchlistList.getTemplateViewModel().watchlist())
    }

    /**
     * Retrieves the state of the batch.
     *
     * @return {Promise} A Promise that resolves with the state of the batch.
     */
    public getBatchState(): Promise<any>{
        return Promise.resolve(this.watchlistList.getTemplateViewModel().batches())
    }

    async removeImagesInArticleContainers() {
        return new Promise((resolve) => {
            const articleContainers = document.querySelectorAll('[data-id-article]');

            articleContainers.forEach(element => {
                const images = element.querySelectorAll('svg');
                images.forEach(image => {
                    image.parentNode.removeChild(image);
                });
            });

            resolve(); // Resolve the Promise when the function is done
        });
    }



}


// WEBPACK FOOTER //
// ./js/modules/watchlist.ts